import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom-v5-compat";
import PropTypes from "prop-types";
import useAuth from "../hooks/useAuth";
import RecoverAccount from "../pages/RecoverPassword";

const HERTZ_COMPANY_ID = 212;
const HERTZ_APP_ORIGIN = "https://hertz.monger.tech";

const AuthGuard = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const hertzRedirectUrl = `${HERTZ_APP_ORIGIN}${location.pathname}${location.search}${location.hash}`;
  const shouldRedirectToHertz =
    auth.isAuthenticated &&
    Number(auth.user?.companyid) === HERTZ_COMPANY_ID &&
    window.location.origin !== HERTZ_APP_ORIGIN;

  useEffect(() => {
    if (shouldRedirectToHertz) {
      window.location.replace(hertzRedirectUrl);
    }
  }, [hertzRedirectUrl, shouldRedirectToHertz]);

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    if (requestedLocation === "/recoverAccount") {
      return <RecoverAccount />;
    } else {
      return <Navigate to="/login" />
    }
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  if (shouldRedirectToHertz) {
    return null;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
